import * as React from 'react'
import { cn } from '@/lib/styles'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	variant?: 'small' | 'large'
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, variant = 'large', ...props }, ref) => {
		const sizeStyles = {
			small: 'h-10',
			large: 'h-11',
		}

		return (
			<input
				type={type}
				ref={ref}
				className={cn(
					'flex w-full py-3.5 text-lg border-neutral-light-500 bg-transparent rounded-sm px-3 shadow-xs transition-colors file:border-0 file:bg-transparent file:text-base file:font-medium placeholder:text-neutral-dark/40 text-neutral-dark focus:border-neutral-light-600 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
					sizeStyles[variant],
					className,
				)}
				{...props}
			/>
		)
	},
)

Input.displayName = 'Input'

export { Input }
